import { combineReducers } from "@reduxjs/toolkit";
import companyFormSlice from "./companyForm";
import globalFunctionsSlice from "./globalFunctions";
import answersSlice from "./answers";
import answeredQuestionsSlice from "./answeredQuestions";

export const rootReducer = combineReducers({
  global: globalFunctionsSlice,
  companyForm: companyFormSlice,
  answers: answersSlice,
  answeredQuestions: answeredQuestionsSlice,
});
